import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CopyPasteBufferService {

    constructor(
    ) {
    }

    public copy(item: any, jsonObject = true) {
        if (jsonObject){
            localStorage.setItem(this.getSectionKey(), JSON.stringify(item));
        }else{
            localStorage.setItem(this.getSectionKey(), item);
        }
    }

    public paste(jsonObject = true): any {
        const lastItem = localStorage.getItem(this.getSectionKey());
        if (lastItem) {
            if (jsonObject) {
                return JSON.parse(lastItem);
            }
            return lastItem;
        }
        return null;
    }

    public reset() {
        localStorage.removeItem(this.getSectionKey());
    }

    public containSomething(jsonObject = true): boolean {
        const something = this.paste(jsonObject);
        if (something) {
            return true;
        }
        return false;
    }

    private getSectionKey(): string {
        return 'elitment-copy-paste-buffer';
    }
}
